import SpamStatusesCard from "./SpamStatusesCard";
export default SpamStatusesCard